require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.for-each");

var eventRegister = function eventRegister(_ref) {
  var ga = _ref.ga,
      location = _ref.location;
  return function (selector, event) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var eventTracker = options.eventTracker,
        beforeCallback = options.beforeCallback,
        afterCallback = options.afterCallback;
    document.body.querySelectorAll(selector).forEach(function (ele, index) {
      ele.addEventListener(event, function () {
        var id = ele.id || 'elements-' + String(index + 1);
        var label = location.href + '#' + id;
        var eventCategory = selector.replace(/^\./, '').replace(/^#/, '');

        if (eventTracker instanceof Function) {
          return eventTracker(ga, ele, event, eventCategory, label);
        }

        defaultEventTracker(ga, ele, event, eventCategory, label, {
          beforeCallback: beforeCallback,
          afterCallback: afterCallback
        });
      });
    });
  };
};

var defaultEventTracker = function defaultEventTracker(ga, ele, eventAction, eventCategory, eventLabel, options) {
  var beforeCallback = options.beforeCallback,
      afterCallback = options.afterCallback;
  beforeCallback instanceof Function && beforeCallback(ga, ele, eventAction, eventLabel);
  var object = {
    eventAction: eventAction,
    eventCategory: eventCategory,
    eventLabel: eventLabel
  };
  ga('send', 'event', object);
  afterCallback instanceof Function && afterCallback(ga, ele, object);
};

var batchEventRegister = function batchEventRegister(_ref2, selectors, event, options) {
  var ga = _ref2.ga,
      location = _ref2.location;
  return selectors.forEach(function (selector) {
    return eventRegister({
      ga: ga,
      location: location
    })(selector, event, options);
  });
};

module.exports = {
  eventRegister: eventRegister,
  batchEventRegister: batchEventRegister
};